module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg5-7326a04fa5e4a04f3394185eb2790786.svg";